import download from "downloadjs";
import ToastEventBus from "primevue/toasteventbus";

// Tope de espera de una descarga (PDF, XML, Excel, ZIP). Sin él, axios espera
// para siempre y el botón queda girando sin ninguna señal para el usuario, que
// fue exactamente el reporte del 2026-10-07 con una proforma. Generoso porque
// los Excel de ventas/compras por rango pueden tardar.
export const DOWNLOAD_TIMEOUT_MS = 120000;

export const DOWNLOAD_TIMEOUT_MESSAGE = "La descarga tardó demasiado. Revisa tu conexión e inténtalo de nuevo.";
const GENERIC_MESSAGE = "No se pudo generar el archivo, inténtalo nuevamente.";

function isJsonBlob(blob) {
    return !!(blob.type && blob.type.indexOf("json") !== -1);
}

// Motivo legible del fallo: el `error` del objeto que devuelve httpRequest, el
// `error` del JSON que el backend mandó en vez del archivo (403 sin permiso,
// 502 sin sesión, 422 con mensaje), o un texto genérico.
async function failureDetail(response) {
    if (response instanceof Blob) {
        try {
            const body = JSON.parse(await response.text());
            if (body && body.error) return body.error;
        } catch (e) { /* blob no legible: cae al genérico */ }
        return GENERIC_MESSAGE;
    }
    return (response && response.error) || GENERIC_MESSAGE;
}

/**
 * Guarda en disco lo que devolvió un helper de descarga de httpRequest, o avisa
 * por qué no se pudo. Devuelve true si se entregó el archivo al navegador.
 *
 * Los helpers devuelven un Blob cuando la respuesta es el archivo y un objeto
 * `{status, error}` cuando el request falló. Pero el backend también responde
 * HTTP 200 con un JSON de error, que con `responseType: 'blob'` llega como Blob:
 * guardarlo como .pdf daba un archivo basura de pocos bytes y ningún aviso.
 *
 * `toast` es `this.$toast` del componente; sin él se usa el toast global
 * (group "global", montado en AppWrapper.vue).
 */
export async function saveDownload(response, filename, mime, toast) {
    if (response instanceof Blob && !isJsonBlob(response)) {
        download(response, filename, mime);
        return true;
    }
    const message = {
        severity: "error",
        summary: "Descarga no disponible",
        detail: await failureDetail(response),
        life: 5000,
    };
    if (toast && typeof toast.add === "function") {
        toast.add(message);
    } else {
        ToastEventBus.emit("add", { ...message, group: "global" });
    }
    return false;
}
